import React from 'react';
import { TileBox } from '../../../projects/preview/components/tile-box/TileBox';

interface AgencyStatsTilesProps {
  groupCount: number;
  projectCount: number;
  promptCount: number;
  projectsDelta: number;
  promptsDelta: number;
  isLoading: boolean;
}

const AgencyStatsTiles: React.FC<AgencyStatsTilesProps> = ({
  groupCount,
  projectCount,
  promptCount,
  projectsDelta,
  promptsDelta,
  isLoading,
}) => {
  const hasData = !isLoading;

  return (
    <div className="tiles tiles--page">
      <TileBox
        hasData={hasData}
        label="groups"
        tooltipText="groupsTooltip"
        value={groupCount}
        trendValue={0}
      />
      <TileBox
        hasData={hasData}
        label="agencyStatsProjects"
        tooltipText="projectsTooltip"
        value={projectCount}
        trendValue={projectsDelta}
      />
      <TileBox
        hasData={hasData}
        label="agencyStatsPrompts"
        tooltipText="promptsTooltip"
        value={promptCount}
        trendValue={promptsDelta}
      />
    </div>
  );
};

export default AgencyStatsTiles;
